import { render, staticRenderFns } from "./MyDraftNotifications.vue?vue&type=template&id=21690207"
import script from "./MyDraftNotifications.vue?vue&type=script&lang=js"
export * from "./MyDraftNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports